module.exports = __webpack_public_path__ + "static/media/progress_note.7187cb20.svg";